import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './components/pages/HomePage';
import PhilosophyPage from './components/pages/PhilosophyPage';
import ContactPage from './components/pages/ContactPage';
import TermsPage from './components/pages/TermsPage'; // New import
import PrivacyPage from './components/pages/PrivacyPage'; // New import
import MarketTicker from './components/ticker/MarketTicker';
import utils, { useMarketData } from './utils/marketData';
import './App.css';

function App() {
  const { marketData, loading } = useMarketData();

  // Fallback to static data if marketData is not available
  const markets = loading ? utils.getMarketData() : marketData;

  const location = useLocation();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/philosophy" element={<PhilosophyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} /> {/* New route */}
          <Route path="/privacy" element={<PrivacyPage />} /> {/* New route */}
        </Routes>
      </main>
      <MarketTicker markets={markets} />
      <Footer />
    </div>
  );
}

export default App;